import { Box } from '@mui/material';

import TabsPanel from '../../components/TabsPanel';
import { manageAccountTabs } from '../../constants/tabRoutes';
import { useHasPermission } from '../../hooks/useHasPermission';

const ManageAccountTabsView = () => {
  const canViewApiService = useHasPermission('API Service', 'View');

  const tabs = manageAccountTabs.filter(
    (tab) => tab.path !== 'api-service' || canViewApiService,
  );

  return (
    <Box display="flex" width="100%">
      <TabsPanel tabsList={tabs} locationSlicePosition={2} />
    </Box>
  );
};

export default ManageAccountTabsView;
